import { Select } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"

const GiftCardSelect = ({
  control,
  fontSize,
  id,
  selectStyle,
  name,
  options,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Select
          fontSize={fontSize}
          id={id}
          {...field}
          {...selectStyle}
          width="100%"
        >
          {options.map((time) => {
            let value = time
            let text = time
            if (id === "timezone_gift_card") {
              value = time[1]
              text = time[0]
            }
            return (
              <option key={text} value={value}>
                {text}
              </option>
            )
          })}
        </Select>
      )}
    />
  )
}

GiftCardSelect.propTypes = {
  control: PropTypes.object.isRequired,
  fontSize: PropTypes.number,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectStyle: PropTypes.object,
}

export default GiftCardSelect
